/** Canonical origin: every canonical, og:url, sitemap and JSON-LD URL starts with it (never the request's host). */
export const SITE_ORIGIN = 'https://www.perzo.art';
